import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import Loader from "components/Loader";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div className="flex justify-center items-center h-screen w-full">
      <Suspense fallback={<Loader fullPage />}>
        <Routes>
          {getRoutes(routes)}
          <Route
            path="/"
            element={<Navigate to="/auth/sign-in" replace />}
          />
        </Routes>
      </Suspense>
    </div>
  );
}
